import transactionsReducer from './transactionsReducer';

export default transactionsReducer;
